import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// ---------- ihale -> sunum işi eşlemesi ----------
const DURUM_MAP = {
  tamamlandi: 'tamamlanan',
  gecici_kabul: 'tamamlanan',
  devam_ediyor: 'devam',
  yikim_sureci: 'devam',
  // planlanan, proje_asamasinda, ihale_surecinde, iptal_edildi, tasfiye_edildi -> planlanan
};

const parseMoney = (value) => {
  if (!value) return 0;
  let cleaned = String(value).trim().replace(/[^\d.,]/g, '');
  if (!cleaned) return 0;
  if (cleaned.includes(',')) {
    cleaned = cleaned.replace(/\./g, '').replace(',', '.');
  } else {
    const dots = (cleaned.match(/\./g) || []).length;
    if (dots > 1) cleaned = cleaned.replace(/\./g, '');
    else if (dots === 1 && cleaned.split('.')[1].length === 3) cleaned = cleaned.replace('.', '');
  }
  const n = parseFloat(cleaned);
  return isFinite(n) ? n : 0;
};

const parsePct = (v) => {
  const n = parseFloat(String(v || '').replace('%', '').replace(',', '.'));
  return isFinite(n) ? Math.max(0, Math.min(100, Math.round(n))) : 0;
};

const normDate = (v) => {
  if (!v) return '';
  const s = String(v).trim();
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  const m = s.match(/^(\d{1,2})[./](\d{1,2})[./](\d{4})/);
  if (m) return `${m[3]}-${m[2].padStart(2, '0')}-${m[1].padStart(2, '0')}`;
  return '';
};

const mapIhale = (i) => ({
  id: i.id,
  ad: i.isin_adi || i.ihale_no || 'İş',
  konum: i.ilcesi || '',
  durum: DURUM_MAP[i.durumu] || 'planlanan',
  alimTuru: i.alim_turu || 'yapim',
  yuzde: parsePct(i.fiziki_ilerleme),
  bedel: parseMoney(i.guncel_sozlesme_bedeli_3 || i.guncel_sozlesme_bedeli_2 || i.guncel_sozlesme_bedeli_1 || i.sozlesme_bedeli),
  yaklasikMaliyet: parseMoney(i.yaklasik_maliyet),
  hakedis: parseMoney(i.toplam_odenen_hakedis),
  yuklenici: i.ihaleyi_alan_firma || '',
  baslama: normDate(i.yer_teslim_tarihi),
  bitis: normDate(i.bitis_tarihi),
  ihaleKayitNo: i.kayit_no || i.ihale_no || '',
  ihaleTarihi: normDate(i.ihale_tarihi),
  sozlesmeTarihi: normDate(i.sozlesme_tarihi),
  gecKabul: normDate(i.gecici_kabul_tarihi),
  adaParsel: '',
  aciklama: i.aciklama || '',
  fotolar: [],
});

const KURUM_ADI = 'İstanbul Gençlik ve Spor İl Müdürlüğü';
const SUNUM_BASLIK = 'Yatırım ve Projeler Sunumu';

const injectTemplate = (tpl, isler, cfg) => {
  const safe = (o) => JSON.stringify(o).replace(/</g, '\\u003c');
  return tpl
    .replace(/\/\*CFG\*\/[\s\S]*?\/\*CFG_END\*\//, `/*CFG*/${safe(cfg)}/*CFG_END*/`)
    .replace(/\/\*DATA\*\/[\s\S]*?\/\*DATA_END\*\//, `/*DATA*/${safe(isler)}/*DATA_END*/`);
};

// İzleyici için iframe içine enjekte edilen salt-görüntüleme katmanı:
// düzenleme/silme/ekleme/tema/logo/dışa aktarma kontrolleri gizlenir,
// başlık alanları kilitlenir ve iframe içi indirme yolları kapatılır.
const VIEWER_READONLY_SNIPPET = `
<style id="viewer-readonly-style">
  [data-act="edit"], [data-act="del"], [data-act="yeni"], [data-act="reset"], [data-act="webGuncelle"],
  [data-act="saveForm"], [data-act="fotoAdd"], [data-act="fotoDel"],
  [data-act="logoSec"], [data-act="logoSil"], [data-act="tema"], [data-act="temaMenu"],
  [data-act="pdf"], [data-act="pptx"],
  [data-testid="sunum-tab-yonetim"], .web-note { display: none !important; }
  #sunum-baslik-input, #sunum-kurum-input { pointer-events: none !important; user-select: none; }
  #modal { display: none !important; }
</style>
<script>
(function(){
  function uyar(){
    try {
      var d = document.createElement('div');
      d.textContent = 'İzleyici yetkisi ile dosya indirme/dışa aktarma yapılamaz';
      d.style.cssText = 'position:fixed;bottom:20px;left:50%;transform:translateX(-50%);background:#7f1d1d;color:#fff;padding:10px 18px;border-radius:8px;z-index:99999;font-size:13px;box-shadow:0 6px 20px rgba(0,0,0,.5)';
      document.body.appendChild(d);
      setTimeout(function(){ d.remove(); }, 3000);
    } catch(e) {}
  }
  var oc = URL.createObjectURL.bind(URL);
  URL.createObjectURL = function(o){ if (o instanceof Blob) { uyar(); throw new Error('viewer-blocked'); } return oc(o); };
  var ocl = HTMLAnchorElement.prototype.click;
  HTMLAnchorElement.prototype.click = function(){ if (this.hasAttribute('download')) { uyar(); return; } return ocl.apply(this, arguments); };
  var od = HTMLAnchorElement.prototype.dispatchEvent;
  HTMLAnchorElement.prototype.dispatchEvent = function(ev){ if (ev && ev.type === 'click' && this.hasAttribute('download')) { uyar(); return false; } return od.call(this, ev); };
  window.print = function(){ uyar(); };
})();
</script>`;

export default function SunumOlusturucuPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isViewer = !!user?.is_viewer && !user?.is_admin;
  const iframeRef = React.useRef(null);
  const [tpl, setTpl] = useState(null);
  const [isler, setIsler] = useState(null);
  const [webCfg, setWebCfg] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (user && !user.is_admin && !user.can_view_grafikler && !user.is_viewer) {
      navigate('/dashboard');
      return;
    }
    Promise.all([
      fetch('/sunum-sablon.html').then((r) => r.text()),
      axios.get(`${API}/ihaleler`, { withCredentials: true }),
    ])
      .then(([tplText, ihRes]) => {
        setTpl(tplText);
        setIsler((ihRes.data || []).map(mapIhale));
      })
      .catch(() => setError('Veriler yüklenemedi. Sayfayı yenileyip tekrar deneyin.'));
  }, [user, navigate]);

  // İframe içindeki "🔄 Verileri Güncelle" butonu: İhaleler'den en güncel verileri çeker,
  // kullanıcının oturumda seçtiği tema/logo/başlıklar korunarak sunum yeniden yüklenir
  useEffect(() => {
    const onMsg = async (e) => {
      if (e?.data?.type !== 'sunum-veri-guncelle') return;
      try {
        const res = await axios.get(`${API}/ihaleler`, { withCredentials: true });
        let live = null;
        try { live = iframeRef.current?.contentWindow?.__getSunumState?.(); } catch (err) { /* güvence */ }
        if (live) {
          setWebCfg({
            kurumAdi: live.kurumAdi, sunumBaslik: live.sunumBaslik, themeId: live.themeId,
            logo: live.logo, logoScale: live.logoScale, alanlar: live.alanlar,
          });
        }
        setIsler((res.data || []).map(mapIhale));
        toast.success(`Veriler güncellendi — İhaleler sayfasından ${(res.data || []).length} iş çekildi`);
      } catch (err) {
        toast.error('Güncel veriler alınamadı. Sayfayı yenileyip tekrar deneyin.');
      }
    };
    window.addEventListener('message', onMsg);
    return () => window.removeEventListener('message', onMsg);
  }, []);

  const srcDoc = useMemo(() => {
    if (!tpl || !isler) return null;
    let html = injectTemplate(tpl, isler, {
      webMode: true,
      buildId: 'web',
      kurumAdi: webCfg?.kurumAdi || KURUM_ADI,
      sunumBaslik: webCfg?.sunumBaslik || SUNUM_BASLIK,
      ...(webCfg ? { themeId: webCfg.themeId, logo: webCfg.logo, logoScale: webCfg.logoScale, alanlar: webCfg.alanlar } : {}),
    });
    if (isViewer) html = html.replace('</body>', `${VIEWER_READONLY_SNIPPET}</body>`);
    return html;
  }, [tpl, isler, isViewer, webCfg]);

  const downloadHtml = async () => {
    if (!tpl || !isler) return;
    // Çevrimdışı dosyanın "Güncel Verileri Çek" özelliği için senkron anahtarı al
    let syncToken = null;
    try {
      const res = await axios.post(`${API}/sunum/sync-token`, {}, { withCredentials: true });
      syncToken = res.data?.token || null;
    } catch (e) { /* token alınamazsa dosya yine iner; çevrimdışı JSON yükleme kullanılabilir */ }
    // İndirme anında iframe içindeki güncel durumu (oturum düzenlemeleri, logo, tema) al
    let live = null;
    try { live = iframeRef.current?.contentWindow?.__getSunumState?.(); } catch (e) { /* cross-origin olmaz ama güvence */ }
    const now = new Date();
    const stamp = now.toISOString().slice(0, 10);
    const html = injectTemplate(tpl, (live && live.isler) || isler, {
      webMode: false,
      buildId: String(now.getTime()),
      kurumAdi: (live && live.kurumAdi) || KURUM_ADI,
      sunumBaslik: (live && live.sunumBaslik) || SUNUM_BASLIK,
      themeId: (live && live.themeId) || 'lacivert',
      logo: (live && live.logo) || null,
      logoScale: (live && live.logoScale) || 100,
      alanlar: (live && live.alanlar) || null,
      backendUrl: process.env.REACT_APP_BACKEND_URL,
      syncToken,
      veriZamani: now.toISOString(),
    });
    const blob = new Blob([html], { type: 'text/html;charset=utf-8' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `Sunum-Olusturucu-${stamp}.html`;
    a.click();
    URL.revokeObjectURL(a.href);
  };

  const downloadJson = () => {
    if (!isler) return;
    const stamp = new Date().toISOString().slice(0, 10);
    const blob = new Blob([JSON.stringify({ isler }, null, 2)], { type: 'application/json;charset=utf-8' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `sunum-veri-${stamp}.json`;
    a.click();
    URL.revokeObjectURL(a.href);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-950 via-gray-900 to-gray-950 flex flex-col">
      <header className="bg-gray-900/50 border-b border-gray-800 backdrop-blur-sm sticky top-0 z-10">
        <div className="px-4 py-3 flex items-center justify-between flex-wrap gap-3">
          <div className="flex items-center space-x-4">
            <img src="/logo.png" alt="GSB Logo" className="w-10 h-10 object-contain cursor-pointer" onClick={() => navigate('/dashboard')} />
            <div>
              <h1 className="text-lg font-bold text-white flex items-center gap-2">🎬 Sunum Oluşturucu {isViewer && <span className="text-[11px] font-semibold bg-amber-800/70 text-amber-200 px-2 py-0.5 rounded-full" data-testid="sunum-viewer-badge">İzleyici — Salt Görüntüleme</span>}</h1>
              <p className="text-xs text-gray-400">{isViewer ? 'Sunumu görüntüleyebilirsiniz; düzenleme ve indirme kapalıdır' : 'İhale verileriniz otomatik yüklendi · Fotoğraf eklemek için HTML indirin'}</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Button onClick={() => navigate('/grafikler')} variant="ghost" className="text-gray-300 hover:text-white" data-testid="sunum-grafikler-nav">← Grafikler</Button>
            <Button onClick={() => navigate('/finance/ihaleler')} variant="ghost" className="text-gray-300 hover:text-white" data-testid="sunum-ihaleler-nav">İhaleler</Button>
            {!isViewer && (
              <>
                <Button
                  onClick={downloadJson}
                  disabled={!srcDoc}
                  variant="outline"
                  className="border-gray-700 text-gray-300 hover:text-white hover:bg-gray-800"
                  title="Çevrimdışı sunum dosyasındaki 'Güncel Verileri Çek' özelliği için yedek veri dosyası (internet olmadan güncelleme)"
                  data-testid="sunum-json-indir-btn"
                >
                  🗂 Veri (JSON)
                </Button>
                <Button
                  onClick={downloadHtml}
                  disabled={!srcDoc}
                  className="bg-emerald-600 hover:bg-emerald-700 text-white font-semibold"
                  data-testid="sunum-html-indir-btn"
                >
                  💾 HTML İndir (Çevrimdışı Sürüm)
                </Button>
              </>
            )}
          </div>
        </div>
      </header>

      <div className="flex-1 flex flex-col">
        {error && (
          <div className="m-6 p-4 bg-red-900/30 border border-red-700/50 rounded-lg text-red-200 text-sm" data-testid="sunum-error">
            {error}
          </div>
        )}
        {!error && !srcDoc && (
          <div className="flex-1 flex items-center justify-center text-gray-400" data-testid="sunum-loading">
            Sunum oluşturucu hazırlanıyor…
          </div>
        )}
        {srcDoc && (
          <iframe
            ref={iframeRef}
            title="Sunum Oluşturucu"
            srcDoc={srcDoc}
            className="flex-1 w-full border-0"
            style={{ minHeight: 'calc(100vh - 70px)' }}
            data-testid="sunum-iframe"
          />
        )}
      </div>
    </div>
  );
}
